import React from 'react';

export const NotFound = () => {
  return (
    <div>
      <h2>This page was not found</h2>
    </div>
  );
};
